"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
function useQueryString(paramName, initialValue, options) {
    const history = (0, react_router_dom_1.useHistory)();
    const { search } = (0, react_router_dom_1.useLocation)();
    const urlParams = (0, react_1.useMemo)(() => new URLSearchParams(search), [search]);
    const validateValue = (v) => !v || !(options === null || options === void 0 ? void 0 : options.allowedValues) || (options === null || options === void 0 ? void 0 : options.allowedValues.includes(v)) ? v : initialValue;
    const [value, setValue] = (0, react_1.useState)(validateValue(urlParams.get(paramName)));
    (0, react_1.useEffect)(() => {
        const urlValue = urlParams.get(paramName);
        if (urlValue && urlValue !== value) {
            setValue(validateValue(urlValue));
        }
        else if (!urlValue && value) {
            setValue(null);
        }
    }, [urlParams]);
    const onSetValue = (0, react_1.useCallback)((newValue) => {
        var _a;
        setValue(newValue);
        const urlValue = urlParams.get(paramName);
        if (newValue && newValue !== urlValue) {
            urlParams.set(paramName, newValue);
            history.push({ search: urlParams.toString() });
        }
        else if (urlValue && newValue === null) {
            urlParams.delete(paramName);
            (_a = options === null || options === void 0 ? void 0 : options.dependencies) === null || _a === void 0 ? void 0 : _a.forEach((x) => urlParams.delete(x));
            history.push({ search: urlParams.toString() });
        }
    }, [paramName, urlParams]);
    return [value, onSetValue];
}
exports.default = useQueryString;
